import type { FrontendRuntimeLogLevel } from './runtimeLogger'
import { logFrontendRuntimeEvent } from './runtimeLogger'

export const emitFrontendDiagnostic = ({
  app,
  level,
  event,
  message,
  context,
  error,
}: {
  app: 'admin' | 'shop'
  level: FrontendRuntimeLogLevel
  event: string
  message: string
  context?: Record<string, unknown>
  error?: unknown
}) => {
  logFrontendRuntimeEvent({
    app,
    level,
    event,
    message,
    context,
    error,
  })
}
